module.exports = __webpack_public_path__ + "img/NovvanLogo.6ad621e0.svg";